module.exports = __webpack_public_path__ + "img/circle3.28da7ad0.png";